<template>
  <div class="app" v-title data-title="预订服务-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="4" />
    <div class="yj-banner rel">
      <img src="@/assets/images/yd-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/pages/yinxiang/index" class="f16 fw">预订服务</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">预订服务</div>
        <div class="f17 ls3">Reservation Services</div>
      </div>
    </div>
    <div class="spot-cont mt-40 pb100">
      <div class="spot-tit df align_center justify_center">
        <h2 class="f32 foo pb15">休闲娱乐</h2>
      </div>
      <div class="spot-item df flex_wrap w1200 auto pt20">
        <div class="spot-box wp33" v-for="item in list" :key="item.Id">
          <div class="db rel ml12 mr12 mt24 spot-link">
            <img v-if="item.Photo" :src="item.Photo + '!/both/752x1002'" class="db wp100" alt="">
            <div v-if="item.Name" class="spot-box-text df align_center justify_center">
              <span class="fw f18 spot-box-text-name">{{ item.Name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pages df align_center justify_center pt50 pb50">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="filter.total"
          :current-page="filter.Page"
          :page-size="filter.PageSize"
          @current-change="handleCurrentPage">
        </el-pagination>
      </div>
    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'
import activityService from '@/services/client/cont/activity'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',
      filter: {
        Page: 1,
        PageSize: 12,
        total: 0,
      },
      list: null,
    }
  },
  components: { Header, Bottom,},
  mounted() {
    this.loadData();
  },
  methods:{
    loadData() {
      this.list = null;
      activityService.list(this.filter).then(res => {
        if(res.Code == 200 && res.Data && res.Data.List && res.Data.List.length > 0) {
          this.list = res.Data.List;

          this.filter.total = res.Data.Count;
        }
      })
    },
    handleCurrentPage(page) {
      this.filter.Page = page;
      this.loadData();
    }
  },

}
</script>
<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>



// WEBPACK FOOTER //
// src/views/yuding/leisure.vue